import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Award, ArrowRight } from "lucide-react";
import api from "../lib/api";
import Reveal from "../components/Reveal";
import { PillButton, Overline } from "../components/primitives";

export default function Founders() {
  const [founders, setFounders] = useState([]);
  useEffect(() => { api.get("/founders").then((r) => setFounders(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-16 md:pt-20">
      <section className="py-20 md:py-28 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <Reveal>
            <Overline>Meet the Founders</Overline>
            <h1 className="mt-4 font-display font-extrabold tracking-tighter text-4xl md:text-6xl leading-[0.98]">Aida & Edwin Colindres</h1>
            <p className="mt-5 text-lg text-foreground/70">Equal co-founders, hybrid coaches, and your hosts for every retreat.</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-28">
        <div className="max-w-6xl mx-auto px-6 md:px-10 space-y-20">
          {founders.map((f, i) => (
            <Reveal key={f.id}>
              <div className={`grid md:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}>
                <div className="md:[direction:ltr] overflow-hidden rounded-3xl h-[28rem]">
                  <img src={f.photo} alt={f.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="md:[direction:ltr]">
                  <h2 className="font-display font-extrabold text-3xl md:text-4xl">{f.name}</h2>
                  <div className="mt-2 text-primary font-medium">{f.title}</div>
                  <p className="mt-5 text-foreground/75 leading-relaxed whitespace-pre-line">{f.bio}</p>
                  {f.certifications?.length > 0 && (
                    <div className="mt-6 flex flex-wrap gap-2">
                      {f.certifications.map((c, k) => (
                        <span key={k} className="inline-flex items-center gap-1.5 rounded-full bg-secondary px-3 py-1.5 text-xs font-medium"><Award className="w-3.5 h-3.5 text-primary" /> {c}</span>
                      ))}
                    </div>
                  )}
                  <div className="mt-6 flex gap-3">
                    {f.socials?.instagram && <a href={f.socials.instagram} target="_blank" rel="noreferrer" className="text-foreground/50 hover:text-primary"><Instagram /></a>}
                    {f.socials?.facebook && <a href={f.socials.facebook} target="_blank" rel="noreferrer" className="text-foreground/50 hover:text-primary"><Facebook /></a>}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="text-center mt-16">
          <Link to="/book"><PillButton>Train With Us in El Salvador <ArrowRight className="w-4 h-4" /></PillButton></Link>
        </div>
      </section>
    </div>
  );
}
